/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { v4 as uuidv4 } from 'uuid';
import {
  Modal, Checkbox, Loader, Popup, List, Segment, Dimmer
} from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';
import $ from 'jquery';
import api from '../../api';
import NewLocalGroupModal from '../Modal/NewLocalGroupModal';
import SettingContentsHeaderByGroups from './SettingContentsHeaderByGroups';
import downIcon from '../../images/components/content_wide_card/headerSorting (down).png';
import upIcon from '../../images/components/content_wide_card/headerSorting (up).png';
import EditLocalGroupModal from '../Modal/EditLocalGroupModal';
import WithRouter from '../Extensions/WithRouter';

class GroupSetting extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpenAlert: false,
      isOpenMCG: false,
      isOpenMEG: false,
      isOpenMDG: false,
      isLocalSetting: false,
      isPageLoading: false,
      pageSize: 10,
      currentPage: 1,
      groupList: [],
      isSort: false,
      sortColumn: '1',
      error: null,
      //hasMore: true,
      isLoading: false,
      isNextLoading: false,
      itemsChecked: false,
      memberList: [],
      projectList: [],
      checkValue: [],
      popupStatus: {
        memberPopup: false,
        projectPopup: false,
      },
      activeIndex: '',
    };

    this.onChangeSorting = this.onChangeSorting.bind(this);
    this.clearSearch = this.clearSearch.bind(this);
    this.handleOnScroll = this.handleOnScroll.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleMCGOpen = this.handleMCGOpen.bind(this);
    this.handleMCGClose = this.handleMCGClose.bind(this);
    this.handleMDGOpen = this.handleMDGOpen.bind(this);
    this.handleMDGClose = this.handleMDGClose.bind(this);
    this.handleAlertClose = this.handleAlertClose.bind(this);
    this.handleCheckChange = this.handleCheckChange.bind(this);
    this.handleGroupCheckAll = this.handleGroupCheckAll.bind(this);
    this.handleNewGroupCallback = this.handleNewGroupCallback.bind(this);
    this.handleMEGOpen = this.handleMEGOpen.bind(this);
    this.handleMEGClose = this.handleMEGClose.bind(this);
    this.handleEditLocalGroupCallback = this.handleEditLocalGroupCallback.bind(this);
    this.deleteGroup = this.deleteGroup.bind(this);
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleOnScroll);
    if (this.groupSetting) {
      this.onUpdateLoading();
    }
    const $contentsHeader = $('.contents_header');
    const $tableHeader = $('.setting_table_header');
    const $window = $(window);

    $window.on('scroll.contents_header', () => {
      if ($window.scrollTop() > 0) {
        $contentsHeader.addClass('fixed');
        $tableHeader.addClass('fixed');
      } else {
        $contentsHeader.removeClass('fixed');
        $tableHeader.removeClass('fixed');
      }
    });
  }

  componentDidUpdate(prevProps, prevState) {
    const { isPageLoading } = this.state;
    const { location } = this.props;
    if (prevState.isOpenAlert !== this.state.isOpenAlert || prevState.isOpenMCG !== this.state.isOpenMCG || prevState.isOpenMDG !== this.state.isOpenMDG || prevState.isOpenMEG !== this.state.isOpenMEG) {
      this.handleClose();
    }

    if (prevState.isLoading !== isPageLoading && isPageLoading) {
      this.getsGroupList();
      this.setState({
        isPageLoading: false,
      });
    }

    if (prevProps.location && location) {
      const currentPath = location.pathname ? location.pathname : location;
      const prevPath = prevProps.location.pathname ? prevProps.location.pathname : prevProps.location;
      if (currentPath !== prevPath) {
        this.requiredUser();
      }
    }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleOnScroll);
  }

  handleClose() {
    const status = {
      projectPopup: false,
      memberPopup: false,
    };
    this.setState({
      popupStatus: status,
      activeIndex: '',
    });
  }

  handleOnScroll() {
    const {
      getsGroupList,
      state: { error, isNextLoading, hasMoreGroupList },
    } = this;
    const scrollHeight = Math.max(
      document.documentElement.scrollHeight,
      document.body.scrollHeight
    );
    const scrollTop = Math.max(document.documentElement.scrollTop, document.body.scrollTop);
    const { clientHeight } = document.documentElement;

    if (error || isNextLoading || !hasMoreGroupList) {
      return;
    }

    if (scrollTop + clientHeight >= scrollHeight) {
      getsGroupList(this.state.currentPage + 1);
    }
  }

  handleSearch(value) {
    this.setState(
      {
        searchKeyword: value,
        groupList: [],
        checkValue: [],
      },
      () => {
        this.getsGroupList();
      }
    );
  }

  handleMCGOpen() {
    this.setState({
      isOpenMCG: true,
    });
  }

  handleMCGClose() {
    const { state } = this.props;
    this.setState({
      isOpenMCG: false,
    }, () => {
      state.user.getsGroupCount();
    });
  }

  handleMDGOpen() {
    const { checkValue } = this.state;

    if (checkValue.length === 0) {
      this.setState({
        isOpenAlert: true,
      });
    } else {
      this.setState({
        isOpenMDG: true,
      });
    }
  }

  handleMEGOpen(groupId) {
    this.setState({
      isOpenMEG: true,
      isLocalSetting: true,
      selectedGroupId: groupId,
    });
  }

  handleMEGClose(value) {
    if (value) {
      this.setState(
        {
          searchKeyword: '',
          groupList: [],
          isOpenMEG: false,
          isLocalSetting: false,
        },
        () => {
          this.getsGroupList();
        }
      );
    } else {
      this.setState({
        isOpenMEG: false,
        isLocalSetting: false,
      });
    }
  }

  handleMDGClose() {
    const { state } = this.props;
    this.setState({
      isOpenMDG: false,
    }, () => {
      state.user.getsGroupCount();
    });
  }

  handleAlertClose() {
    this.setState({
      isOpenAlert: false,
    });
  }

  handleCheckChange(e, { value }) {
    const { checkValue, groupList } = this.state;
    let newState;
    if (checkValue.indexOf(value) > -1) {
      newState = checkValue.filter((el) => {
        return el !== value;
      });
    } else {
      newState = [...checkValue, value];
    }
    if (newState.length !== 0 && newState.length !== groupList.length) {
      this.setState({
        checkValue: newState,
        itemsChecked: false,
      });
    } else {
      this.setState({
        checkValue: newState,
      });
    }
  }

  handleGroupCheckAll() {
    const { itemsChecked, groupList } = this.state;
    const newState = [];

    if (itemsChecked) {
      this.setState({
        itemsChecked: false,
        checkValue: [],
      });
    } else {
      const num = groupList.length;
      let i = 0;
      for (i; i < num; i++) {
        newState.push(groupList[i].id);
      }

      const unique = newState.reduce((a, b) => {
        if (a.indexOf(b) < 0) {
          a.push(b);
        }
        return a;
      }, []);
      this.setState({
        itemsChecked: true,
        checkValue: unique,
      });
    }
  }

  handleNewGroupCallback() {
    this.setState(
      {
        groupList: [],
        checkValue: [],
      },
      () => {
        this.getsGroupList();
      }
    );
  }

  handleEditLocalGroupCallback() {
    this.setState(
      {
        groupList: [],
        checkValue: [],
      },
      () => {
        this.getsGroupList();
      }
    );
  }

  onUpdateLoading() {
    this.setState({
      isPageLoading: true,
    });
  }

  onChangeSorting = (e) => {
    const { isSort } = this.state;
    if (e.currentTarget.dataset.id !== this.state.sortColumn) {
      this.setState(
        {
          sortColumn: e.currentTarget.dataset.id,
          isSort: false,
          groupList: [],
        },
        () => {
          this.getsGroupList();
        }
      );
    } else {
      this.setState(
        {
          sortColumn: e.currentTarget.dataset.id,
          isSort: !isSort,
          groupList: [],
        },
        () => {
          this.getsGroupList();
        }
      );
    }
  };

  getsGroupList = (pageNo, limit) => {
    let text;
    const { isSort, sortColumn, groupList } = this.state;
    const { t } = this.props;
    const page = pageNo || 1;
    const perPage = limit || this.state.pageSize;

    switch (true) {
    case sortColumn === '1':
      if (isSort) {
        text = 'group';
      } else {
        text = 'group_r';
      }
      break;
    case sortColumn === '2':
      if (isSort) {
        text = 'member_r';
      } else {
        text = 'member';
      }
      break;
    case sortColumn === '3':
      if (isSort) {
        text = 'project_r';
      } else {
        text = 'project';
      }
      break;
    case sortColumn === '4':
      if (isSort) {
        text = 'modified_r';
      } else {
        text = 'modified';
      }
      break;
    default:
      text = 'modified';
      break;
    }

    if (page === 1) {
      this.setState({
        isLoading: true,
      });
    } else {
      this.setState({
        isNextLoading: true,
      });
    }

    api
      .getsGroupList(
        {
          search: this.state.searchKeyword,
          page,
          limit: perPage,
          order: text,
        }
      )
      .then((response) => {
        if (this.state.groupList.length !== 0 && response.pagination.current === 1) {
          return false;
        }
        const nextGroupList = response.response.map((item) => {
          return {
            id: item.id,
            name: item.name,
            memberCount: item.member_count,
            projectCount: item.project_count,
            lastModified: item.last_modified,
          };
        });
        this.setState({
          //totalCount: response.count,
          currentPage: response.pagination.current,
          //prevPage: response.pagination.previous,
          //nextPage: response.pagination.next,
          pageSize: response.pagination.per_page,
          //totalPage: response.pagination.pages,
          //currentCount: response.pagination.count,
          hasMoreGroupList: response.pagination.next !== null,
          isLoading: false,
          isNextLoading: false,
          groupList: [...groupList, ...nextGroupList],
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          error: t('modal.error.error_load'),
          isLoading: false,
          isNextLoading: false,
        });
      });
  };

  getSGroupMemberDetail = (groupId) => {
    const { t } = this.props;
    const status = {
      projectPopup: false,
      memberPopup: true,
    };
    api
      .getSGroupMemberDetail(groupId)
      .then((response) => {
        const data = response.response;
        this.setState({
          popupStatus: status,
          activeIndex: groupId,
          memberList: data.member_list,
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          error: t('modal.error.error_load'),
          isLoading: false,
        });
      });
  };

  getSGroupProjectDetail = (groupId) => {
    const { t } = this.props;
    const status = {
      projectPopup: true,
      memberPopup: false,
    };
    api
      .getSGroupProjectDetail(groupId)
      .then((response) => {
        const data = response.response;
        this.setState({
          popupStatus: status,
          activeIndex: groupId,
          projectList: data.project_list,
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          error: t('modal.error.error_load'),
          isLoading: false,
        });
      });
  };

  requiredUser() {
    const { state, navigate } = this.props;

    if (!state.user.isUser) {
      if (localStorage.getItem('main_page') === 'dashboard') {
        navigate('/main', { replace: true });
      } else if (localStorage.getItem('main_page') === 'results') {
        navigate('/results', { replace: true });
      } else {
        navigate(`/results/${this.props.state.user.main_page}`, { replace: true });
      }
    }
  }

  clearSearch() {
    this.setState(
      {
        searchKeyword: '',
        checkValue: [],
        groupList: [],
      },
      () => {
        this.getsGroupList();
      }
    );
  }

  deleteGroup() {
    const { t } = this.props;
    const idArr = this.state.checkValue;
    api
      .deletsGroup(
        { group_ids: idArr, }
      )
      .then((response) => {
        if (response.status === 200) {
          this.handleMDGClose();
          this.setState(
            {
              groupList: [],
              checkValue: [],
              searchKeyword: '',
              itemsChecked: false,
            },
            () => {
              this.getsGroupList();
            }
          );
        }
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          error: t('modal.error.error_load'),
          isLoading: false,
        });
      });
  }

  render() {
    const {
      error,
      isLoading,
      isNextLoading,
      isSort,
      sortColumn,
      groupList,
      itemsChecked,
      checkValue,
      activeIndex,
    } = this.state;

    const { location, state, t } = this.props;
    const pathname = location.pathname ? location.pathname : location;

    return (
      <div
        className="setting_group"
        ref={(ref) => {
          this.groupSetting = ref;
        }}
      >
        <SettingContentsHeaderByGroups
          clearSearch={this.clearSearch}
          onChangeSearch={this.handleSearch}
          addNewGroup={this.handleMCGOpen}
          deleteGroup={this.handleMDGOpen}
          location={pathname}
          state={state}
          translate={t}
        />
        <div className="content">
          <div className="setting_groups_content">
            <div className="setting_table_header">
              <div className="setting_table_header_inner">
                <table className="setting_groups_table table_header">
                  <colgroup>
                    <col style={{ width: '36px' }} />
                    <col style={{ width: '61%' }} />
                    <col style={{ width: '9.6%' }} />
                    <col style={{ width: '9.6%' }} />
                    <col style={{ width: '9.6%' }} />
                    <col style={{ width: '8%' }} />
                  </colgroup>
                  <thead>
                    <tr>
                      <th>
                        {groupList.length !== 0 && state.user.isAdminOnly && (
                          <Checkbox checked={itemsChecked} onChange={this.handleGroupCheckAll} />
                        )}
                      </th>
                      <th className="group_name">
                        <a className="sorting_button" data-id="1" onClick={this.onChangeSorting}>
                          {t('settings.list.group_name')}
                          {isSort && sortColumn === '1' ? <img src={upIcon} alt="" /> : ''}
                          {!isSort && sortColumn === '1' ? <img src={downIcon} alt="" /> : ''}
                        </a>
                      </th>
                      <th>
                        <a className="sorting_button" data-id="2" onClick={this.onChangeSorting}>
                          {t('settings.list.group_member')}
                          {isSort && sortColumn === '2' ? <img src={upIcon} alt="" /> : ''}
                          {!isSort && sortColumn === '2' ? <img src={downIcon} alt="" /> : ''}
                        </a>
                      </th>
                      <th>
                        <a className="sorting_button" data-id="3" onClick={this.onChangeSorting}>
                          {t('settings.list.applied_projects')}
                          {isSort && sortColumn === '3' ? <img src={upIcon} alt="" /> : ''}
                          {!isSort && sortColumn === '3' ? <img src={downIcon} alt="" /> : ''}
                        </a>
                      </th>
                      <th>
                        <a className="sorting_button" data-id="4" onClick={this.onChangeSorting}>
                          {t('system.list.last_modified')}
                          {isSort && sortColumn === '4' ? <img src={upIcon} alt="" /> : ''}
                          {!isSort && sortColumn === '4' ? <img src={downIcon} alt="" /> : ''}
                        </a>
                      </th>
                      <th>&nbsp;</th>
                    </tr>
                  </thead>
                </table>
              </div>
            </div>
            {
              !isLoading ? (
                <div>
                  {groupList.length !== 0
                    ? groupList.map((list) => {
                      return (
                        <div key={uuidv4()} className="setting_groups_table_wrap">
                          <table className="setting_groups_table">
                            <colgroup>
                              <col style={{ width: '36px' }} />
                              <col style={{ width: '61%' }} />
                              <col style={{ width: '9.6%' }} />
                              <col style={{ width: '9.6%' }} />
                              <col style={{ width: '9.6%' }} />
                              <col style={{ width: '8%' }} />
                            </colgroup>
                            <tbody>
                              <tr>
                                <td>
                                  <div className="content_wrapper">
                                    {state.user.isAdminOnly && (
                                      <Checkbox
                                        value={list.id}
                                        checked={checkValue.indexOf(list.id) > -1}
                                        onChange={this.handleCheckChange}
                                      />
                                    )}
                                  </div>
                                </td>
                                <td className="group_name">
                                  <div className="content_wrapper">{list.name}</div>
                                </td>
                                <td>
                                  <div className="content_wrapper">
                                    {list.memberCount === 0 ? (
                                      <span className="number">{list.memberCount}</span>
                                    ) : (
                                      <Popup
                                        trigger={(
                                          <span className="number" style={{ cursor: 'pointer' }}>
                                            {list.memberCount}
                                          </span>
                                        )}
                                        on="click"
                                        hideOnScroll
                                        position="bottom left"
                                        style={{ marginLeft: '-16.5px' }}
                                        open={
                                          this.state.popupStatus.memberPopup && activeIndex === list.id
                                        }
                                        onOpen={() => {
                                          return this.getSGroupMemberDetail(list.id);
                                        }}
                                        onClose={this.handleClose}
                                      >
                                        <List>
                                          {this.state.memberList.map((item) => {
                                            return (
                                              <List.Item key={uuidv4()}>
                                                <List.Icon name="user" />
                                                <List.Content>{item}</List.Content>
                                              </List.Item>
                                            );
                                          })}
                                        </List>
                                      </Popup>
                                    )}
                                  </div>
                                </td>
                                <td>
                                  <div className="content_wrapper">
                                    {list.projectCount === 0 ? (
                                      <span className="number">{list.projectCount}</span>
                                    ) : (
                                      <Popup
                                        trigger={(
                                          <span className="number" style={{ cursor: 'pointer' }}>
                                            {list.projectCount}
                                          </span>
                                        )}
                                        on="click"
                                        hideOnScroll
                                        position="bottom left"
                                        style={{ marginLeft: '-16.5px' }}
                                        open={
                                          this.state.popupStatus.projectPopup && activeIndex === list.id
                                        }
                                        onOpen={() => {
                                          return this.getSGroupProjectDetail(list.id);
                                        }}
                                        onClose={this.handleClose}
                                      >
                                        <List>
                                          {this.state.projectList.map((item) => {
                                            return (
                                              <List.Item key={uuidv4()}>
                                                <List.Icon name="folder" />
                                                <List.Content>{item}</List.Content>
                                              </List.Item>
                                            );
                                          })}
                                        </List>
                                      </Popup>
                                    )}
                                  </div>
                                </td>
                                <td>
                                  <div className="content_wrapper">{list.lastModified}</div>
                                </td>
                                <td>
                                  <div className="content_wrapper">
                                    <a
                                      className="edit_button"
                                      onClick={() => {
                                        this.handleMEGOpen(list.id);
                                      }}
                                      style={{ cursor: 'pointer' }}
                                    >
                                      {t('system.button.edit')}
                                    </a>
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      );
                    })
                    : null}
                  {error && <div className="error_log">{error}</div>}
                  {isNextLoading && <Loader active={isNextLoading} size="medium">{t('list.title.loading')}</Loader>}
                </div>
              ) : (
                <div>
                  <Segment>
                    <Dimmer active inverted>
                      <Loader size="large">{t('list.title.loading')}</Loader>
                    </Dimmer>
                  </Segment>
                </div>
              )
            }
          </div>
        </div>
        <NewLocalGroupModal
          isOpenMCG={this.state.isOpenMCG}
          closeModal={this.handleMCGClose}
          completeCallback={this.handleNewGroupCallback}
          translate={t}
        />
        <EditLocalGroupModal
          isOpenMEG={this.state.isOpenMEG}
          isLocalSetting={this.state.isLocalSetting}
          groupId={this.state.selectedGroupId}
          closeModal={this.handleMEGClose}
          completeCallback={this.handleEditLocalGroupCallback}
          location={pathname}
          translate={t}
        />
        <Modal open={this.state.isOpenMDG} onClose={this.handleMDGClose}>
          <div className="modal_popup_wrap confirm_wrap">
            <div className="modal_popup_box confirm_box">
              <div className="modal_popup confirm">
                <h2 className="title">{t('modal.title.attention')}</h2>
                <p className="text">{t('settings.message.delete_group')}</p>
                <p className="small_text">{t('settings.message.delete_group_confirm')}</p>
                <div className="button_wrap">
                  <a onClick={this.handleMDGClose} className="left_button">
                    {t('modal.button.cancel')}
                  </a>
                  <a onClick={this.deleteGroup} className="right_button">
                    {t('modal.button.delete')}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </Modal>
        <Modal open={this.state.isOpenAlert} onClose={this.handleAlertClose}>
          <div className="modal_popup_wrap">
            <div className="modal_popup_box">
              <div className="modal_popup">
                <h2 className="title">{t('modal.title.attention')}</h2>
                <p className="text">{t('settings.message.select_one_group')}</p>
                <div className="button_wrap">
                  <a
                    className="center_button"
                    onClick={this.handleAlertClose}
                    style={{ cursor: 'pointer' }}
                  >
                    {t('modal.button.ok')}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

export default WithRouter(withTranslation()(inject('state')(observer(GroupSetting))));
